export default __webpack_public_path__ + "static/media/MargaretEze.4b7f2411.svg";